import {Environment} from '@models/environment/environment';

export const EnvironmentConfig: Environment = {
  productionMode: false,
  CaptchaSettings: {
    captchaKey: '6LdCYqsnAAAAAHT2UFZAs5W7m1-76GErr1T4Elwh'
  },
  PortalSettings: {
    portalTitle: 'Cloudplug Staging Portal',
    ticketSystemEnabled: false,
    environment: 'scitis-cloudplug-testing',
    ssoEnabled: false,
    loginPageEnabled: true,
    externalApiEnabled: true,
    whiteLabelingEnabled: true,
    dataflowEnabled: false,
    monitoringEnabled: false,
    manageSsoAccount: false,
    ssoProfileLink: '',
    apiLocation: 'https://scitis-cloudplug-testing.appspot.com',
    bigTableStreamingEnabled: true,
    tileRefreshInterval: 10,
    tileSamplingInterval: 1,
    interactiveDataAnalysisInterval: 'CURRENT_DAY',
    interactiveDataAnalysisDetailsInterval: 'LAST_7_DAYS',
    machineMapIntervalInMilliseconds: 300_000,
    pagesRefreshInterval: 300,
    colorPalette: ['#634B66', '#A35757', '#5A6B65', '#CB8AC8', '#8DB7C7', '#D5B768', '#9F7FA3', '#D97C7C', '#9CBAB0', '#F0BFEE', '#A5DFF5', '#F5E35A'],
    allowedExternalRedirectUrls: [
      'https://hono.scitis-cloudplug-testing.com/grafana/',
      'https://hono.scitis-cloudplug-testing.com/grafana'
    ],
    nodeFunctionalityEnabled: false
  },
  columnDefinitions: {
    'AIRPURE': ['name', 'tag', 'status', 'connectivity', 'Flow_FQ5_3', 'Pressure_PE6_11', 'Pressure_PE2_5_act', 'Flow_FIE2_1_act', 'Temperatur_TE4_1_act',
      'Temperatur_TE3_2_act', 'tenant'],
    'CASTER': ['name', 'tag', 'status', 'connectivity', 'coilId', 'alloy', 'entryThickness', 'exitThicknessAbs', 'speed', 'exitThicknessDev', 'tenant'],
    'DOPPLER': ['name', 'tag', 'status', 'connectivity', 'coilId', 'alloy', 'entryThickness', 'exitThicknessAbs', 'speed', 'exitThicknessDev', 'tenant'],
    'GRINDER': ['name', 'tag', 'status', 'connectivity', 'coilId', 'alloy', 'entryThickness', 'exitThicknessAbs', 'speed', 'exitThicknessDev', 'tenant'],
    'OVEN': ['name', 'tag', 'status', 'connectivity', 'coilId', 'alloy', 'entryThickness', 'exitThicknessAbs', 'speed', 'exitThicknessDev', 'tenant'],
    'ROILPURE': ['name', 'tag', 'status', 'connectivity', 'Flow_FQ5_3', 'Pressure_PE6_11', 'Pressure_PE2_5_act', 'Flow_FIE2_1_act', 'Temperatur_TE4_1_act',
      'Temperatur_TE3_2_act', 'tenant'],
    'ROLLING_MILL': ['name', 'tag', 'status', 'connectivity', 'coilId', 'alloy', 'entryThickness', 'exitThicknessAbs', 'speed', 'stripWidth', 'tenant'],
    'SEPARATOR': ['name', 'tag', 'status', 'connectivity', 'Unw1DiaAct', 'Unwinder_1_SpeedCircumference', 'Unw1MaterialWidth', 'MaterialThickness',
      'Rew1DiaAct', 'Rew1TensionCalcCharScale', 'tenant'],
    'SLITTER': ['name', 'tag', 'status', 'connectivity', 'Unw1DiaAct', 'Unwinder_SpeedCircumference', 'Unw1MaterialWidth', 'MaterialThickness', 'Rew1DiaAct',
      'Rew1TensionCalcCharScale', 'tenant'],
    'SUPERSTACK': ['name', 'tag', 'status', 'connectivity', 'FilterPart_VacuumPressure', 'DrivePumpOnTime', 'Filter_Part_output_pressure',
      'BFT1_Tank_1_Stirrer_1_speed_set', 'General_running_time_filter', 'Feeding_Line_Flow_actual', 'tenant'],
  },
  firebase: {
    apiKey: 'AIzaSyAl0qHnwO1cDeHLturShL6yr-mHFNkX1h8',
    authDomain: 'scitis-cloudplug-testing.firebaseapp.com',
    databaseURL: 'https://scitis-cloudplug-testing-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'scitis-cloudplug-testing',
    storageBucket: 'scitis-cloudplug-testing.appspot.com',
    messagingSenderId: '263315392268',
    appId: '1:263315392268:web:b691b64e1a2fd6f432eb29',
    measurementId: '',
    debugToken: 'B4EB82B0-B35A-425C-BE6D-4F088EAE3664'
  }
};
